import { render, staticRenderFns } from "./BrScoreCountPie.vue?vue&type=template&id=9f40caf4&scoped=true"
import script from "./BrScoreCountPie.vue?vue&type=script&lang=js"
export * from "./BrScoreCountPie.vue?vue&type=script&lang=js"
import style0 from "./BrScoreCountPie.vue?vue&type=style&index=0&id=9f40caf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f40caf4",
  null
  
)

export default component.exports